import { render, staticRenderFns } from "./videoTemplete.vue?vue&type=template&id=68b086ea&scoped=true&"
import script from "./videoTemplete.vue?vue&type=script&lang=js&"
export * from "./videoTemplete.vue?vue&type=script&lang=js&"
import style0 from "./videoTemplete.vue?vue&type=style&index=0&id=68b086ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b086ea",
  null
  
)

export default component.exports